<template>
  <div class="interview-practice-container">
    <chatbot-component />
  </div>
</template>

<script>
import ChatbotComponent from './ChatbotComponent.vue'

export default {
  name: 'InterviewPractice',
  components: {
    ChatbotComponent
  },
  data() {
    return {
      formSubmitted: false,
      companyInfo: '',
      motivation: ''
    }
  },
  methods: {
  },
  created: function () {

    const app = this

    app.$cookies.config(60 * 60 * 24, '')
    var route_id = app.$cookies.get('_YAGISH_YAGIPRIME_ROUTE_ID')
    app.$cookies.set('_YAGISH_YAGIPRIME_ROUTE_ID', route_id + '#ai_interview', null, null, 'yagish.jp')
    app.$cookies.set('_YAGISH_YAGIPRIME_ROUTE_ID', route_id + '#ai_interview', null, null, 'localhost')
  }
}
</script>

<style scoped>
.interview-practice-container {
  margin: 0 auto;
}

h1 {
  text-align: center;
  margin-bottom: 20px;
}
</style>
